/*
 * PrivacySettings Messages
 *
 * This contains all the text for the PrivacySettings component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    emptyMessage: {
        id: 'app.containers.dataGrid.emptyMessage',
        defaultMessage: 'No data found!'
    },
    subject: {
        id: 'app.containers.defaultCourses.subject',
        defaultMessage: 'Subject'
    }
});



// WEBPACK FOOTER //
// ./app/containers/default-courses/messages.js